var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashcan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.38 24.89"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "trashcan")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.12,24.89H4.26a2,2,0,0,1-2-2.06V7.55a1,1,0,0,1,2,0V22.83l13.89.06,0-15.34a1,1,0,0,1,2,0V22.83A2,2,0,0,1,18.12,24.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38,5.59H1a1,1,0,0,1,0-2H21.38a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14,5.59a1,1,0,0,1-1-1V2.36A.36.36,0,0,0,14.78,2H7.6a.36.36,0,0,0-.36.36V4.59a1,1,0,0,1-2,0V2.36A2.36,2.36,0,0,1,7.6,0h7.18a2.36,2.36,0,0,1,2.36,2.36V4.59A1,1,0,0,1,16.14,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37,21.83A.82.82,0,0,1,7.55,21V7.56a.82.82,0,0,1,1.63,0V21A.82.82,0,0,1,8.37,21.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,21.83A.82.82,0,0,1,13.2,21V7.56a.82.82,0,0,1,1.63,0V21A.82.82,0,0,1,14,21.83Z"
  })))));
}

export default SvgTrashcan;